import api from "../../../services/api";

const getDetailUser = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.get("/userinfo/" + state.userId).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_DETAILUSER", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getDetailUserNew = ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    api.get("/userinfo/" + id).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_DETAILUSER", res.data);
          return res.data;
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const updateUserInfo = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.put("/user/info/" + state.idupdate, state.dataPerson).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const updateEmergency = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.put("/user/emergency", state.datepostemergency).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const getEmergency = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.get("/user/emergency/" + state.userId).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_DETAILEMERGENCY", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getEmergencyNew = ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    api.get("/user/emergency/" + id).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_DETAILEMERGENCY", res.data);
          return res.data;
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getOtherEmploy = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.get("/other/info/" + state.userId).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESOTHERINFO", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const updateOtherInfo = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.put("/karyawan/user", state.dataOtherPost).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const getFamily = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.get("/family/" + state.userId).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESFAMILY", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const updateFamily = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.post("/family/", state.dataFamily).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const getJatahCuti = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.get("/jatahcuti/" + state.userId).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTCUTI", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};

const getLocationSunfish = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api
      .get("/location/sunfish", {
        params: {
          name: state.search
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.status) {
            commit("SET_RESLOCATION", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
const getLocationSunfishById = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api
      .get("/location/sunfish/" + state.idLoc, {
        params: {
          name: state.search
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.status) {
            commit("SET_RESLOC", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
const getProvince = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/location/province").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESPROVINCE", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getCity = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api
      .get("/location/city", {
        params: {
          provinsi: state.provinsi
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.status) {
            commit("SET_RESCITY", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
const getDistrict = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api
      .get("/location/district", {
        params: {
          provinsi: state.provinsi,
          kota: state.city
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.status) {
            commit("SET_RESDISTRICT", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
const getSubDisctrict = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api
      .get("/location/sub_district", {
        params: {
          provinsi: state.provinsi,
          kota: state.city,
          kecamatan: state.district
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.status) {
            commit("SET_RESSUBDISTRICT", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
//

const getProvince1 = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/location/province").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESPROVINCE1", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getCity1 = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api
      .get("/location/city", {
        params: {
          provinsi: state.provinsi
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.status) {
            commit("SET_RESCITY1", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
const getDistrict1 = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api
      .get("/location/district", {
        params: {
          provinsi: state.provinsi,
          kota: state.city
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.status) {
            commit("SET_RESDISTRICT1", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
const getSubDisctrict1 = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api
      .get("/location/sub_district", {
        params: {
          provinsi: state.provinsi,
          kota: state.city,
          kecamatan: state.district
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.status) {
            commit("SET_RESSUBDISTRICT1", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
export default {
  getDetailUser,
  getEmergency,
  updateEmergency,
  updateUserInfo,
  getOtherEmploy,
  updateOtherInfo,
  getFamily,
  updateFamily,
  getJatahCuti,
  getLocationSunfish,
  getLocationSunfishById,
  getProvince,
  getCity,
  getDistrict,
  getSubDisctrict,
  getProvince1,
  getCity1,
  getDistrict1,
  getSubDisctrict1,
  getDetailUserNew,
  getEmergencyNew
};
